import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'clsx';
import { useTheme } from '../../../ThemeProvider';
import GithubButton from '../../GithubButton/GithubButton';
import logoText from '../../../assets/logo-text.svg';
import logoTextWhite from '../../../assets/logo-text-white.svg';
import classes from './Header.styles.less';
export default function Header() {
    const [theme] = useTheme();
    return (_jsxs("header", { className: cx(classes.header, classes[theme]), children: [_jsxs("div", { className: classes.headerBody, children: [_jsx(Link, { to: "/", children: _jsx("img", { className: classes.logo, src: theme === 'light' ? logoText : logoTextWhite, alt: "Logo", width: 340, height: 72 }) }), _jsx("p", { className: classes.description, children: "Open source browser tools for everyday use" })] }), _jsx(GithubButton, {})] }));
}
